import React from 'react';
import {useTranslation} from 'react-i18next';
import NumberInput from '../../../components/NumberInput';
import {FONT_SIZE, IPresentationTheme, getFontSizeTranslationKey} from '../../../../incase-domain/presentationTheme';
import {getUpdatedPresentationThemeElementStyles} from '../../../../utils/presentationTheme';
import Label from '../../../../incase-domain/components/label/Label';

interface PresentationThemeFontSizesProps {
    setPresentationTheme: (theme: IPresentationTheme) => void;
    presentationTheme: IPresentationTheme;
}

export default function PresentationThemeFontSizes(props: PresentationThemeFontSizesProps): JSX.Element {
    const {setPresentationTheme, presentationTheme} = props;

    const {t} = useTranslation();

    const updateFontSize = (size: FONT_SIZE, newValue: number): void => {
        const updatedPresentationTheme = {...presentationTheme};

        if (updatedPresentationTheme.fontSizes) {
            const updatedFontSizes = updatedPresentationTheme.fontSizes.map((fontSize) =>
                fontSize.size === size ? {...fontSize, value: newValue} : fontSize
            );

            if (!updatedFontSizes.some((fontSize) => fontSize.size === size)) {
                updatedFontSizes.push({size, value: newValue});
            }

            updatedPresentationTheme.fontSizes = updatedFontSizes;
            getUpdatedPresentationThemeElementStyles(updatedPresentationTheme, size, newValue);
        }

        setPresentationTheme(updatedPresentationTheme);
    };

    return (
        <div className="u-mt-2">
            <div className="l-grid l-grid--noGaps u-flex u-h-between u-v-center u-mb-1">
                <Label size="lg">{t('presentationThemesPage.fontSizes')}</Label>
                <div className="l-col:10 md:12">
                    <div className="l-grid u-flex u-h-right u-v-bottom">
                        {Object.values(FONT_SIZE).map((size) => {
                            const key = getFontSizeTranslationKey(size);
                            return (
                                <div key={size} className="u-text-center" style={{paddingRight: '10px'}}>
                                    <Label size="md">{key ? t(key) : ''}</Label>
                                    <NumberInput
                                        step={0.1}
                                        min={0.1}
                                        onChange={(newValue) => updateFontSize(size, newValue)}
                                        value={presentationTheme.fontSizes.find((fontSize) => fontSize.size === size)?.value || 1}
                                    />
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </div>
    );
}
